/**
 * Stream a short thread title from `/api/ai/title` (gpt-oss) and invoke
 * `onChunk` with the accumulated text as tokens arrive. Silent on failure —
 * the thread keeps its empty title and the header falls back to "New chat".
 */
export async function streamThreadTitle(
    chatId: string,
    prompt: string,
    onChunk: (accumulated: string) => void,
): Promise<void> {
    try {
        const res = await fetch('/api/ai/title', {
            method: 'POST',
            headers: { 'content-type': 'application/json' },
            body: JSON.stringify({ prompt, chatId }),
        });
        if (!res.ok || !res.body) return;
        const reader = res.body.getReader();
        const decoder = new TextDecoder();
        let acc = '';
        while (true) {
            const { value, done } = await reader.read();
            if (done) break;
            acc += decoder.decode(value, { stream: true });
            const cleaned = acc.replace(/^["'\s]+|["'\s.]+$/g, '');
            if (cleaned.length > 0) onChunk(cleaned);
        }
    } catch {
        // Swallow — title stays empty, header falls back to "New chat".
    }
}
